export const iconFontAwesomeMedicalHealthBedPulse = (
	<i className="fa-solid fa-bed-pulse"></i>
);
